import { Alert, Box } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';

const AlertVerificationBackdrop = () => {
    const userData = useSelector((state) => state.userData.userData);
    return (
        <>
            {userData && userData?.verification_status?.verificationStatus != "Verified" && (
                <Box className="opacity-50 w-100 h-100 position-absolute bg-white z-1" sx={{ cursor: 'not-allowed' }}></Box>

            )
            }
        </>
    )
}

export default AlertVerificationBackdrop;